/**
 * Newsletter CSS styles injection
 *
 * Now uses the shared styleInjector utility.
 *
 * @module lib/newsletter/styles
 */

const { injectStyles } = require('../utils/styleInjector');

/**
 * Newsletter CSS styles
 */
const NEWSLETTER_STYLES = `
.milla-newsletter-box {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}
.milla-newsletter-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 4px;
}
.milla-newsletter-copy {
  font-size: 13px;
  color: #4b5563;
  margin-bottom: 8px;
}
.milla-newsletter-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
  width: 100%;
}
.milla-newsletter-input {
  width: 100%;
  border-radius: 9999px;
  border: 1px solid #e5e7eb;
  padding: 10px 14px;
  font-size: 14px;
  color: #111827;
  background-color: #f9fafb;
  outline: none;
  box-sizing: border-box;
}
.milla-newsletter-input::placeholder {
  color: #9ca3af;
}
.milla-newsletter-input:focus-visible {
  border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb;
  background-color: #ffffff;
}
.milla-newsletter-button {
  width: 100%;
  border-radius: 9999px;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  background: #0f766e;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-sizing: border-box;
}
.milla-newsletter-button:hover {
  background: #115e59;
}
.milla-newsletter-button:disabled {
  opacity: 0.6;
  cursor: default;
}
.milla-newsletter-message {
  font-size: 12px;
  margin-top: 4px;
  text-align: center;
}
.milla-newsletter-message-success {
  color: #047857;
}
.milla-newsletter-message-error {
  color: #b91c1c;
}
.milla-newsletter-message-pending {
  color: #4b5563;
}
.milla-newsletter-inline-card {
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;
  padding: 14px 16px;
  margin: 12px 0;
  width: 100%;
  box-sizing: border-box;
}
`;

/**
 * Welcome-email notice on native forms (lib/newsletter/form.js). Injected on
 * its own because RebelMouse templates may not load NEWSLETTER_STYLES.
 */
const NEWSLETTER_NOTICE_STYLES = `
.milla-newsletter-notice {
  display: block;
  font-size: 12px;
  line-height: 1.45;
  color: #4b5563;
  margin: 4px 0 0;
}
`;

/**
 * Inject newsletter styles into the document
 */
function ensureNewsletterStyles() {
  injectStyles('milla-newsletter-inline-styles', NEWSLETTER_STYLES);
}

function ensureNewsletterNoticeStyles() {
  injectStyles('milla-newsletter-notice-styles', NEWSLETTER_NOTICE_STYLES);
}

module.exports = { ensureNewsletterStyles, ensureNewsletterNoticeStyles };
